import { Alert, Button, Flex, Form, Input } from 'antd';
import axios from 'axios';
import md5 from 'md5';
import { useNavigate } from 'react-router-dom';
import { apiBasePath, sessionStorageKey_session } from '../../../utils/constants';
import { useContext, useState } from 'react';
import { GlobalContext } from '../../../utils/globalContext';
import { normalizeMenuProfile } from '../../../utils/normalizer';
import { withTrimmedForm } from '../../../utils/utils';

const LoginForm = () => {
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [alert, setAlert] = useState(null);
  const { setUser, setMenuRoutes } = useContext(GlobalContext);
  const navigate = useNavigate();
  const onFinish = async (values) => {
    setLoader(true);
    try {
      const responseLoginUser = await axios.post(`${apiBasePath}/customer/login`, {
        userName: values.userName,
        authType: 1,
        password: md5(values.userPass)
      });
      // Set user data in context
      const userData = { ...responseLoginUser.data, isAdmin: true };

      setUser(userData);
      // Set session in storage
      sessionStorage.setItem(sessionStorageKey_session, JSON.stringify(userData));
      const menuProfile = normalizeMenuProfile({ isAdmin: true });

      setMenuRoutes(menuProfile);
      setLoader(false);
      // Redirect to home or dashboard
      navigate('/');
    } catch (error) {
      setAlert({
        type: 'error',
        message: 'Tuvimos problemas al iniciar tu sesión',
        description: error.status === 403 ? error.response.data.message : 'Por favor, intenta de nuevo'
      });
      setLoader(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
    setLoader(false);
  };

  return (
    <>
      {alert && (
        <Alert
          message={alert.message}
          description={alert.description}
          type={alert.type}
          closable={true}
          banner={true}
          onClose={() => setAlert(null)}
          className="login-alert"
          showIcon
        />
      )}
      <Flex className="login-form-container">
        <img src={`${process.env.PUBLIC_URL}/logoBdi.jpg`} alt="logo" className="login-logo" />
        <Form
          name="login"
          form={form}
          layout="vertical"
          onFinish={withTrimmedForm(onFinish)}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          className="login-form">
          <Form.Item
            label="Usuario"
            name="userName"
            rules={[
              {
                required: true,
                message: 'Escriba su Usuario'
              }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label="Contraseña"
            name="userPass"
            rules={[
              {
                required: true,
                message: 'Escriba su Contraseña'
              }
            ]}>
            <Input.Password />
          </Form.Item>
          <Flex justify="center" vertical className="login-form-buttons">
            <Button type="primary" htmlType="submit" loading={loader}>
              Entrar
            </Button>
          </Flex>
        </Form>
      </Flex>
    </>
  );
};

export { LoginForm };
